export default __webpack_public_path__ + "static/educaTuRegionAbout-d9c74e1c138524c9a890f7abec785e3b.png";